export { default } from "./edgeAttributes";
